<template>
  <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.30762 9.51661C6.30762 9.07479 6.66579 8.71661 7.10762 8.71661L24.6297 8.71661C25.0715 8.71661 25.4297 9.07478 25.4297 9.51661C25.4297 9.95844 25.0715 10.3166 24.6297 10.3166L7.10762 10.3166C6.66579 10.3166 6.30762 9.95844 6.30762 9.51661Z" fill="black"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.30762 15.9902C6.30762 15.5484 6.66579 15.1902 7.10762 15.1902L24.6297 15.1902C25.0715 15.1902 25.4297 15.5484 25.4297 15.9902C25.4297 16.4321 25.0715 16.7902 24.6297 16.7902L7.10762 16.7902C6.66579 16.7902 6.30762 16.4321 6.30762 15.9902Z" fill="black"/>
    <path fill-rule="evenodd" clip-rule="evenodd" d="M6.30762 22.4547C6.30762 22.0129 6.66579 21.6547 7.10762 21.6547L24.6297 21.6547C25.0715 21.6547 25.4297 22.0129 25.4297 22.4547C25.4297 22.8966 25.0715 23.2547 24.6297 23.2547L7.10762 23.2547C6.66579 23.2547 6.30762 22.8966 6.30762 22.4547Z" fill="black"/>
  </svg>
</template>

<script>
export default {
  name: 'menuIconMobile'
}
</script>

<style scoped>

</style>
